import React, { useMemo } from "react";
import { Ad } from "../types";
import withRedux from "../withRedux";
import Loader from "../components/loader";
import sanitizeHTML from "sanitize-html";

type Props = {
	ads: Ad[];
	match: {
		params: {
			campaign: string;
		};
	};
};

function getAd(ads: Ad[], campaign: string): null | Ad {
	if (ads === null) {
		return null;
	}

	return ads.find((ad) => {
		return ad.campaign === campaign;
	});
}

function createMarkup(richContent: string): { __html: string } {
	const html = sanitizeHTML(richContent, {
		allowedTags: [
			"h1",
			"h2",
			"h3",
			"h4",
			"h5",
			"h6",
			"p",
			"a",
			"strong",
			"b",
			"i",
			"em",
			"u",
			"ol",
			"ul",
			"li",
			"img",
			"div",
		],
		allowedAttributes: {
			a: ["href", "title"],
			div: ["class"],
			img: ["src"],
		},
	});
	return { __html: html };
}

const Campaign = ({ ads, match }: Props) => {
	const ad = useMemo(() => getAd(ads, match.params.campaign), [match.params.campaign, ads]);

	if (ads === null) {
		return <Loader />;
	}

	if (ad === null) {
		return "no ad";
	}

	return (
		<div className="dealPage">
			<div className="wrap">
				<div className="deal">
					<div className="hero" style={{ backgroundImage: `url(${ad.mainPicture}` }} />
					<div className="content">
						{ad.brandName ? (
							<div className="brand">
								<a href={ad.brandUrl} target="_blank" rel="noopener noreferrer">
									{ad.brandName}
								</a>
							</div>
						) : null}
						<div className="title">{ad.title}</div>
						{ad.richContent ? (
							<div
								className="richDescription"
								dangerouslySetInnerHTML={createMarkup(ad.richContent)}
							></div>
						) : null}
						{ad.link && ad.linkName ? (
							<div className="callToAction">
								<a href={ad.link} className="button" target="_blank" rel="noopener noreferrer">
									{ad.linkName}
								</a>
							</div>
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({ deals: { ads } }, ownProps) => {
	return { ads };
};

export default withRedux({}, mapStateToProps)(Campaign);
